theme.jQuery(function($) {

	// Open newsletter popup button
	$('.js-open-newsletter-popup').click(function(event) {
		event.preventDefault();

		// Open Omnisend modal
		$('.soundest-form-image-left-open')[0].click();
	});

	// Force any add to cart buttons to use first add to cart button on product page to ensure ajax cart works
	$('.js-add-to-cart-secondary').click(function(event) {
		event.preventDefault();

		$('.js-add-to-cart-primary').click();
	});

});
